import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { ItemControllerRoom } from '.';

/**
 *部屋モバイルitemControllerクラス
 */
export default class ItemControllerRoomMobile extends ItemControllerRoom {
  target: marietta.webcad.item.Room;

  cornerPickerList: marietta.webcad.control.parts.RoomCornerDragger[];

  roomDragger: marietta.webcad.control.parts.RoomDraggerMobile;

  roomDraggerLocalPoint: marietta.core.Point;

  startPoint: marietta.core.Point;

  dragStartPoint: marietta.core.Point;

  motoPoint: marietta.core.Point;

  x: number;

  y: number;

  width: number;

  height: number;

  prevPoint: marietta.core.Point;

  currentWall;

  moveAmountX: number;

  moveAmountY: number;

  startCoordinatesWall: marietta.webcad.collection.PointCollection[];

  isDragging: boolean;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    // ターゲット
    this.target = _target as marietta.webcad.item.Room;

    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    this.spt = new SVGSprite(viewObj);

    // ビューの初期化
    this.initMe();

    // 初期化
    this.isDragging = false;

    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }
  }

  /**
   * 初期化
   */
  initMe() {
    if (document.getElementById('controller')) {
      document.getElementById('controller').remove();
    }
    this.cornerPickerList = [];

    // コントローラー追加
    const points: number = this.target.itemInfo.dotList.length;
    let corner: marietta.webcad.control.parts.RoomCornerDragger;
    for (let i: number = 1; i <= points; i += 1) {
      corner = new marietta.webcad.control.parts.RoomCornerDragger(this.spt, i);
      corner.moveFunc = this.onMoveCornerDragger;
      corner.moveEndFunc = this.onMoveEndCornerDragger;
      this.cornerPickerList.push(corner);
    }

    // 移動Dragger
    this.roomDragger = new marietta.webcad.control.parts.RoomDraggerMobile(this.spt);
    this.roomDragger.dragFunc = this.onMoveRoomDragger;
    this.roomDragger.dragEndFunc = this.onMoveEndRoomDragger;

    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    tarLayer.spt.addChild(this.spt);
    // コントローラーの位置調整
    this.setArrowPositions();

    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;

    // cornerDragの開始時に測定線を非表示にする
    marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();
    // 開始時のアイテム場所保持
    if (this.startPoint === undefined || this.startPoint === null) {
      this.currentWall = target;
      this.cornerXPartners = [];
      this.cornerYPartners = [];

      if (this.emptySpt === undefined) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );

      // 前後のドットをみて同期して動くドットを選定
      const parnerDotList = [];
      // 前のドット
      if (this.currentWall.index === 1) {
        parnerDotList.push(this.cornerPickerList[this.cornerPickerList.length - 1]);
      } else {
        parnerDotList.push(this.cornerPickerList[this.currentWall.index - 2]);
      }
      // 次のドット
      if (this.currentWall.index === this.cornerPickerList.length) {
        parnerDotList.push(this.cornerPickerList[0]);
      } else {
        parnerDotList.push(this.cornerPickerList[this.currentWall.index]);
      }
      for (let i: number = 0; i < parnerDotList.length; i += 1) {
        if (this.currentWall.x === parnerDotList[i].x) this.cornerXPartners.push(parnerDotList[i]);
        if (this.currentWall.y === parnerDotList[i].y) this.cornerYPartners.push(parnerDotList[i]);
      }
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * this.target.spt.scaleX,
      this.emptySpt.mouseY * this.target.spt.scaleY,
    );

    // アイテムの角度分、座標変換を行う
    const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
    newPoint.x = xx;
    newPoint.y = yy;

    const snapPosition: marietta.core.Point = ItemControllerRoom.getSnapPosition(newPoint);
    target.move(snapPosition.x, snapPosition.y);

    // 隣接ドットの同期
    for (let i: number = 0; i < this.cornerXPartners.length; i += 1) {
      this.cornerXPartners[i].moveX(snapPosition.x);
    }
    for (let i: number = 0; i < this.cornerYPartners.length; i += 1) {
      this.cornerYPartners[i].moveY(snapPosition.y);
    }

    // 部屋を同期させる
    this.setRoomToMe();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndCornerDragger = () => {
    this.startPoint = null;
    this.currentWall = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
    // 面積ゼロなら削除
    ItemControllerRoom.areaZeroRemove();
    // ライン測定を更新する
    marietta.webcad.WebCADGlobal.updateMeasureLine(false);
    // cornerDragの最後に測定線を表示する
    marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveRoomDragger = () => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfMove()) return;

    let corner: marietta.webcad.control.parts.RoomCornerDragger;
    let i: number;

    // 開始時のアイテム場所保持
    if (this.dragStartPoint === undefined || this.dragStartPoint === null) {
      if (this.emptySpt === undefined) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.roomDragger.spt);
        this.roomDragger.spt.parent.addChild(this.emptySpt);
      }

      // アイテムの元位置
      this.motoPoint = new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y);
      this.dragStartPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );

      // ドラッガーの元位置
      this.roomDragger.saveOriginalPoisition();
      // ピッカーの元位置
      for (i = 0; i < this.cornerPickerList.length; i += 1) {
        corner = this.cornerPickerList[i];
        corner.saveOriginalPoisition();
      }
      // 子供を隠す
      this.target.hideChildren();
      this.target.previousPlace = this.motoPoint;
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * this.target.spt.scaleX,
      this.emptySpt.mouseY * this.target.spt.scaleY,
    );

    const moveX: number = newPoint.x - this.dragStartPoint.x;
    const moveY: number = newPoint.y - this.dragStartPoint.y;
    const snapPoint: marietta.core.Point = ItemControllerRoomMobile.snapToGrid(moveX, moveY);
    this.target.move(this.motoPoint.x + snapPoint.x, this.motoPoint.y + snapPoint.y);

    this.roomDragger.move(this.roomDragger.originalPosition.x + snapPoint.x, this.roomDragger.originalPosition.y + snapPoint.y);
    // ピッカーの元位置
    for (i = 0; i < this.cornerPickerList.length; i += 1) {
      corner = this.cornerPickerList[i];
      corner.move(corner.originalPosition.x + snapPoint.x, corner.originalPosition.y + snapPoint.y);
    }
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndRoomDragger = () => {
    this.dragStartPoint = null;

    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }

    // 子供の移動
    this.target.moveChildren();
    // 子供の表示
    this.target.showChildren();

    // マウスアップの挙動
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
  }

  /**
   * グリッドに吸い付く
   * */
  private static snapToGrid(x: number, y: number): marietta.core.Point {
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    const newX = Math.round(x / snapUnit) * snapUnit;
    const newY = Math.round(y / snapUnit) * snapUnit;

    return new marietta.core.Point(newX, newY);
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).updateTranslate();
    }
  }

  /**
   * 部屋の大きさをあわせる
   * */
  resizeRoomToMe(force: Boolean = false) {
    if (force) this.prevPoint = null;

    // 前回と同じ位置なら、行わない
    if (this.prevPoint != null && (this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY)) return;
    this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

    // ドラッグ開始時の頂点をコピー
    const newCoordinates: marietta.webcad.collection.PointCollection[] = [];
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      newCoordinates.push(new marietta.webcad.collection.PointCollection(this.startCoordinatesWall[i].x, this.startCoordinatesWall[i].y, this.startCoordinatesWall[i].wall_type));
    }
    // ドラッグしている辺に影響する頂点の座標を変更する
    const { index } = this.currentWall as marietta.webcad.control.parts.RoomMovePicker;
    const p1: number = index - 1;
    const p2: number = (index === this.cornerPickerList.length) ? 0 : index;

    // 方向を特定する
    let vertical: Boolean = false;
    if ((this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === -90) {
      vertical = true;
    }
    // 方向を特定する
    if ((this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation % 90 === 0 || (this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === 0) {
      if ((this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === -90) {
        vertical = true;
      }
      // 頂点を変更する
      newCoordinates[p1].x += vertical ? 0 : this.moveAmountX;
      newCoordinates[p1].y += vertical ? this.moveAmountY : 0;
      newCoordinates[p2].x += vertical ? 0 : this.moveAmountX;
      newCoordinates[p2].y += vertical ? this.moveAmountY : 0;
    } else {
      // 頂点を変更する
      newCoordinates[p1].x += this.moveAmountX;
      newCoordinates[p1].y += this.moveAmountY;
      newCoordinates[p2].x += this.moveAmountX;
      newCoordinates[p2].y += this.moveAmountY;
    }
    this.target.itemInfo.dotList = newCoordinates;
    this.target.reCreateImage();
    // 関連するシンボルの位置移動
    this.setArrowPositions();
  }

  /**
   * 矢印位置を合わせる
   * */
  setArrowPositions() {
    // 頂点作成
    let cornerPicker: marietta.webcad.control.parts.RoomCornerDragger;
    let i: number;
    let minX: number = null;
    let maxX: number = null;
    let minY: number = null;
    let maxY: number = null;
    for (i = 0; i < this.cornerPickerList.length; i += 1) {
      cornerPicker = this.cornerPickerList[i];
      cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);

      if (minX === null || this.target.itemInfo.dotList[i].x < minX) minX = this.target.itemInfo.dotList[i].x;
      if (minY === null || this.target.itemInfo.dotList[i].y < minY) minY = this.target.itemInfo.dotList[i].y;
      if (maxX === null || this.target.itemInfo.dotList[i].x > maxX) maxX = this.target.itemInfo.dotList[i].x;
      if (maxY === null || this.target.itemInfo.dotList[i].y > maxY) maxY = this.target.itemInfo.dotList[i].y;
    }
    // 中央へ移動
    this.roomDragger.move(minX + (maxX - minX) / 2, minY + (maxY - minY) / 2);
    this.roomDraggerLocalPoint = new marietta.core.Point((maxX - minX) / 2, (maxY - minY) / 2);
    // お掃除
    cornerPicker = null;
  }

  /**
   * ツールチップを非表示
   */
  hideToolTips() {
    this.roomDragger.hide();
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).disableDragger();
    }
  }

  /**
   * ツールチップを表示する
   */
  showToolTips() {
    this.roomDragger.show();
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).enableDragger();
    }
  }
}
